
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoJogUh_4568cGQpas8_45WA9tB_USzw1ULLMzcnpV50JJvWUMeta } from "/var/www/2025-06-20_18_41/pages/edo.vue?macro=true";
import { default as helpl95OkX_45Ou01PVjVJbVaUSy8EtJ21S4gynhstMYB99pQMeta } from "/var/www/2025-06-20_18_41/pages/help.vue?macro=true";
import { default as cargoxO6d7xYwUUd1QFqvXIcTT4a3OIixaOjDQJ_45X4EHrTUIMeta } from "/var/www/2025-06-20_18_41/pages/cargo.vue?macro=true";
import { default as chinazLIYN32QHvMtfyepVzkyyDR_EOYYQyq9B82a4GTZpfgMeta } from "/var/www/2025-06-20_18_41/pages/china.vue?macro=true";
import { default as indexxZ1KOxwMVfxr9K5fQc3jCt2b_j3you5uQUyu5TeRNCIMeta } from "/var/www/2025-06-20_18_41/pages/index.vue?macro=true";
import { default as _91slug_934Z_45LFUpbPLDSPuWGnAd0eJtuxh9CzgRaVVSjohlNR88Meta } from "/var/www/2025-06-20_18_41/pages/[slug].vue?macro=true";
import { default as belarusB2JhcnuLpZvBOWV4Fs0IdGVYOtxXq43rKJotzhplq0sMeta } from "/var/www/2025-06-20_18_41/pages/belarus.vue?macro=true";
import { default as bonusesWZtNCdy0rNVlfWRaPqVxiFSL2FZ3tihVzPi5QJ76nw8Meta } from "/var/www/2025-06-20_18_41/pages/bonuses.vue?macro=true";
import { default as apirDEquv5TGsYGze4UQ86C257N7aohcgbe6lf2xSkDSL0Meta } from "/var/www/2025-06-20_18_41/pages/dev/api.vue?macro=true";
import { default as cmsbFZa_45CP5dqBUeImNsa02bwqZjmibCNSQwP3xEyB_4546oMeta } from "/var/www/2025-06-20_18_41/pages/dev/cms.vue?macro=true";
import { default as konkursGY7WozxhENOA_45xSRESbIh6DthjyQddUD0ASJ4SgLQkcMeta } from "/var/www/2025-06-20_18_41/pages/konkurs.vue?macro=true";
import { default as successDa_uQ_mjvwcUPR_45IgNiM2fGiqxrtTqyi1QROtQPqAucMeta } from "/var/www/2025-06-20_18_41/pages/success.vue?macro=true";
import { default as tariffsbXIM9DUrjzbtINE_WIItslMwuKBi9o3vIxX_N_45HKShwMeta } from "/var/www/2025-06-20_18_41/pages/tariffs.vue?macro=true";
import { default as vacancybeI2lu8fS_GtUeQnwSbPRK064JrvIb7qNEO393Zh_ywMeta } from "/var/www/2025-06-20_18_41/pages/vacancy.vue?macro=true";
import { default as contactsw2qFJvpMnEq7px1X_yTIC91LBKtjCEm9BRzFEj9w3lUMeta } from "/var/www/2025-06-20_18_41/pages/contacts.vue?macro=true";
import { default as giveawayMmeuLNC0tJP89U2E26A8zxc9rB44II3AevcgJIzm99QMeta } from "/var/www/2025-06-20_18_41/pages/giveaway.vue?macro=true";
import { default as guide_45lkHDC796oONAWKm3ykSoXEkACnS_qlGh_Q9QLRrjf33k8Meta } from "/var/www/2025-06-20_18_41/pages/guide-lk.vue?macro=true";
import { default as services_Fa0xA22pNJEoH0TG8YgIF3G4MAK5oWwxd7hvH9L3zsMeta } from "/var/www/2025-06-20_18_41/pages/services.vue?macro=true";
import { default as telegramV18iEjGIBW1gJ91zGtHb1HnYzxEsyJuMIwMVaKfpGhQMeta } from "/var/www/2025-06-20_18_41/pages/telegram.vue?macro=true";
import { default as documentsdsW8F9c6zIOaBB_7iW4Kbo9d8Oqmuig6wWpvJOMqVWMMeta } from "/var/www/2025-06-20_18_41/pages/documents.vue?macro=true";
import { default as franchiser44r5TRIsL6cb3y6esIvYw2_45hjHCRawhfo_N8oTNNz0Meta } from "/var/www/2025-06-20_18_41/pages/franchise.vue?macro=true";
import { default as insurancehbhtz1U_45lpUb2bloCjAcyUckOwUAQjQTEzFoiCjqtakMeta } from "/var/www/2025-06-20_18_41/pages/insurance.vue?macro=true";
import { default as kirghiziaIRpooJx81HrUDqzoKM5h0hg_45Jwf8fHw0dJuOaDMGI4wMeta } from "/var/www/2025-06-20_18_41/pages/kirghizia.vue?macro=true";
import { default as mapSchemeUwkHIx_45g20YsvAhTRhhqbGHA0TpwCIrDsbHIhvLcLcsMeta } from "/var/www/2025-06-20_18_41/pages/mapScheme.vue?macro=true";
import { default as _91id_93vGcHOrstk1QU_A7FAHSHWzLB5IKj28c1rXfH8nR7iBAMeta } from "/var/www/2025-06-20_18_41/pages/news/[id].vue?macro=true";
import { default as return_45sdhDjwkhVqPT71pRiYECg2Zml01oa_45qiHRdkuzt4zkcC8Meta } from "/var/www/2025-06-20_18_41/pages/return-sd.vue?macro=true";
import { default as smsClientXz5tZDC1AQr3m6HkNe5DBEEwnbL7Q7aFIhddvYZIcb8Meta } from "/var/www/2025-06-20_18_41/pages/smsClient.vue?macro=true";
import { default as terminalsHwHGC0o1ACSQemrIsbNdGWsT8qrCXKg1vX1eENN8Uu8Meta } from "/var/www/2025-06-20_18_41/pages/terminals.vue?macro=true";
import { default as iframeeYaK602ctP0IBzgN5aUl1MIuE3Jx1RMokTSl6F6wWQ0Meta } from "/var/www/2025-06-20_18_41/pages/dev/iframe.vue?macro=true";
import { default as directionsQ9qmVnOzskaLjBnRTk4wyHWrG4eeBtkEH_61nBXNKaEMeta } from "/var/www/2025-06-20_18_41/pages/directions.vue?macro=true";
import { default as kazakhstanzN6PvyH_a6Y27XDWp426ulE5SmchU2fBX_fDdY7yt8kMeta } from "/var/www/2025-06-20_18_41/pages/kazakhstan.vue?macro=true";
import { default as indexG_45eT5wb5JupZCmUWidvHfIGFAswREpvD0GdMQZYBo2YMeta } from "/var/www/2025-06-20_18_41/pages/news/index.vue?macro=true";
import { default as svgTT7yvT0k4hS0C556TBH8QjLpNx3n8K5gQqLYFH9nxVUMeta } from "/var/www/2025-06-20_18_41/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failduE_CfX6UD6nzCZHDceEP1AzpEiPHZ1cuBOv09ov0OUMeta } from "/var/www/2025-06-20_18_41/pages/vzpay-fail.vue?macro=true";
import { default as constructor39aMEy8Q00_45dUBGwzWLcPykXd0TEAkcvdWFXG_x88P0Meta } from "/var/www/2025-06-20_18_41/pages/constructor.vue?macro=true";
import { default as indexGKo_Qf4txA4xrsAlAST45a_K5FI58OWiKiIM_JZbva4Meta } from "/var/www/2025-06-20_18_41/pages/gifts/index.vue?macro=true";
import { default as informationbp_451oVugXck5PVK2WHJxHMOntirgFtN_ht3GLARAliQMeta } from "/var/www/2025-06-20_18_41/pages/information.vue?macro=true";
import { default as lightdZ6m5d793l8_N0Vr0OJAqorjfrWkQ_45zTBS1DBWIG4csMeta } from "/var/www/2025-06-20_18_41/pages/order/light.vue?macro=true";
import { default as claim_45filingx2mQwbJdLj3xiQYxJqiDRxzBUN29q2BRoDa4kNCaHCsMeta } from "/var/www/2025-06-20_18_41/pages/claim-filing.vue?macro=true";
import { default as _91type_93GMuf3Gb_45aCaTjz1QSQWypX5QmSXSiv7PZrTJ4wuuoG8Meta } from "/var/www/2025-06-20_18_41/pages/gifts/[type].vue?macro=true";
import { default as marketplaces8Vd_45JGd6sae8d8QNkWWIxpYpA_45x9ZQ5xuZ72znkM_456kMeta } from "/var/www/2025-06-20_18_41/pages/marketplaces.vue?macro=true";
import { default as networkshopsKc6PKW5iapNe_45GrmKVd6I_vvB80VWuz_UjHI_45W_45lpIsMeta } from "/var/www/2025-06-20_18_41/pages/networkshops.vue?macro=true";
import { default as online_45store1MLQ0bGyV2zT_45yCzEeyEEyJIrXsh5wPlQ4xisisae3oMeta } from "/var/www/2025-06-20_18_41/pages/online-store.vue?macro=true";
import { default as manage3xlxOEJ1dRolJbZTOt4hWMy5Pz6ECNntJ6KNDyPkk3IMeta } from "/var/www/2025-06-20_18_41/pages/order/manage.vue?macro=true";
import { default as registration0TXSvji3bkuzAiD_45y0GdvCt2M9jBPe18jnolIo2_45y70Meta } from "/var/www/2025-06-20_18_41/pages/registration.vue?macro=true";
import { default as run_45scheduleKxft28vouIzLXgq_451yaum_45punuR6z6qY5VwOlBJnyJkMeta } from "/var/www/2025-06-20_18_41/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyvddukI_F7bH2_45q_ccWAhwuorwjq6xpIRL7lIFLwGyFMMeta } from "/var/www/2025-06-20_18_41/pages/safe-custody.vue?macro=true";
import { default as imageqYnbc1FLMQ5DLdCXdFvO0z7mjpvdTyRI56hHceP8YgsMeta } from "/var/www/2025-06-20_18_41/pages/ui-kit/image.vue?macro=true";
import { default as indexbMgndGX_9tEG9g6RW9r4qWUuMJ7_tNky_ANX0TSmKWcMeta } from "/var/www/2025-06-20_18_41/pages/ui-kit/index.vue?macro=true";
import { default as bagE7Vf8gND_df2tZrh5qYfxqczXIO4ps3n90n8nieJ_lAMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/bag.vue?macro=true";
import { default as boxVCRSsh6WU7RZLBDIJHkjBm5SeBamc2mfntGvdQu9jw0Meta } from "/var/www/2025-06-20_18_41/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingOobxCZEDu_458w8S_45ftqzZsKjFiPFwZm0PGBXpIh4S3AcMeta } from "/var/www/2025-06-20_18_41/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayk0PeYBDJfnF7mDEQ7pujIhv5NLgZmcPKYc_45r_Q_45ILOAMeta } from "/var/www/2025-06-20_18_41/pages/happybirthday.vue?macro=true";
import { default as manageVFuoZvwjGMoYtr6yxm0phec4xlL9W2lJWzGUWkATZXIMeta } from "/var/www/2025-06-20_18_41/pages/iframe/manage.vue?macro=true";
import { default as authSJJiS6ptTvuUmf_59pamOS1Mp_450oGjFd473CoU3DVwcMeta } from "/var/www/2025-06-20_18_41/pages/personal/auth.vue?macro=true";
import { default as publicevfBqL_45ToHgtXdbb88H348dgap1GqheducYJF_1mhG4Meta } from "/var/www/2025-06-20_18_41/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerrivcKR894plzUZk_YqhUDjUM6ygng7iqjjDm_45VwKrOcMeta } from "/var/www/2025-06-20_18_41/pages/already-answer.vue?macro=true";
import { default as tariffszI4VZN_Vc06A4HWvxEwjF_oLR59vcnQjlzBluSaKmeAMeta } from "/var/www/2025-06-20_18_41/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93bq2_1UBkwuXnrWe25mPeIs6fkvgBSJH8OhsjjrwkcIoMeta } from "/var/www/2025-06-20_18_41/pages/order/pay/[id].vue?macro=true";
import { default as indexBCzQL2WUVsxMKSvkQve9rWTVyCBCIiZa33vM3RM5xu4Meta } from "/var/www/2025-06-20_18_41/pages/personal/index.vue?macro=true";
import { default as privacy_45policydmZyJGLb_o5decy88NYzeOkz5NApUeJjBuv0R6wIfg4Meta } from "/var/www/2025-06-20_18_41/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93emQHR_45Sv34pR24u09GmdqkDgrt54BTyyEFnvPrQk9LkMeta } from "/var/www/2025-06-20_18_41/pages/welcome/[hash].vue?macro=true";
import { default as indexH1WWFzo2FVsC3ahaF_45tSNNEXYxU0dlGZZ2GJ473SWgUMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaXYB0mbvCfejT5he5r2mRXDL_ddxrkAI0xteoyNpi6A4Meta } from "/var/www/2025-06-20_18_41/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodskR6MvBR0vvayVxkU6JumblC3VIqmoNT1nYlPNxfWJu0Meta } from "/var/www/2025-06-20_18_41/pages/payment-methods.vue?macro=true";
import { default as qr_45infoPpTzxiZxCKnOOR1BIMS6lcv276OGQ0sAeuZUlsonVhAMeta } from "/var/www/2025-06-20_18_41/pages/payment/qr-info.vue?macro=true";
import { default as successCVmIKsRgASd7GZkG9b3UpeRq6B3gXNd6bvW0tXcTf_4Meta } from "/var/www/2025-06-20_18_41/pages/payment/success.vue?macro=true";
import { default as importwmfHETvEJNnHnq8NGbr0r8l2gYEs8qzC7wu1S157CMkMeta } from "/var/www/2025-06-20_18_41/pages/personal/import.vue?macro=true";
import { default as logout9c4uKJ37I9Marz6VlHrU_mLiQ9pQkfCZQkLX8j_45TrdEMeta } from "/var/www/2025-06-20_18_41/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryiq6XCyU_45hlxgNKDRn_KsAkmo4qEwgTlaqmmKC6zWKKAMeta } from "/var/www/2025-06-20_18_41/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryknvVfPYSjW5lZ20J7TgGTpOI2P_mlJkU6m2B9xNr0icMeta } from "/var/www/2025-06-20_18_41/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024OVEFshMTxdomjfCNLa1J1W6gSDDiX3ydh3AmgvBhW00Meta } from "/var/www/2025-06-20_18_41/pages/happynewyear2024.vue?macro=true";
import { default as ozonA0d03QU_4585b0SBUs0fnmZ3o50KEYDJlAOJk3fxsBHcgMeta } from "/var/www/2025-06-20_18_41/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failMdzSrf9IzGal060r2SYnlheBoYBvdi4ya5rWQQH_45dh0Meta } from "/var/www/2025-06-20_18_41/pages/payment/pay-fail.vue?macro=true";
import { default as account6yJSvX_GkhKTBJjcZbBnWIgElbF3KerZ0osUVIRaeskMeta } from "/var/www/2025-06-20_18_41/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsVDHd0_yQLxZOjbKQ65R7iCBEHI70CL5OGkgQW6h_45GpcMeta } from "/var/www/2025-06-20_18_41/pages/prohibited-goods.vue?macro=true";
import { default as directionEfvgVlw7jDEcXVL2I_45VGPaGivYbw9T4OpH_Cj_HWa88Meta } from "/var/www/2025-06-20_18_41/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupVRxy7JW_7tV7wt2v3LuG6sgqn0PaZe5pGINE6aaYzMcMeta } from "/var/www/2025-06-20_18_41/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargo0ztJDXcOf1HD0k42EJQm54P6vkIrqXtrwIbswobMDQQMeta } from "/var/www/2025-06-20_18_41/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorPPKlUe11CX9FDlChTfM2bEXPw_45BKWhTHrL3sDGL3aEQMeta } from "/var/www/2025-06-20_18_41/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesyTPLak2Yd3ZE_45sVTRcRNp_459yndOddkqowBXWRb1xGAEMeta } from "/var/www/2025-06-20_18_41/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93EYHFPuTz6tSZsXGmasJA3A21D93QvDp8T3phz28pXP0Meta } from "/var/www/2025-06-20_18_41/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoTlxjEP2aHjXX3z9eaJSsIm0s036nOUrapM9d5p_TjCwMeta } from "/var/www/2025-06-20_18_41/pages/payment/card-info.vue?macro=true";
import { default as discountAhUH_45oN6NCLvUSplTz_45Jvu98HRHuGAO3F2PL3dRqICEMeta } from "/var/www/2025-06-20_18_41/pages/personal/discount.vue?macro=true";
import { default as hard_45boxrfjHXAjcT2ljbDAqcavNFc6zo_b_45WbYqW9yS__AiWfgMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptPVGmVdRTpPsMfrJVs6KMErfgfOhdOY1Bqw0Q_45zSbEi4Meta } from "/var/www/2025-06-20_18_41/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917r1HXmRMCOK_8nNtuevBTlADLJojscdpEWVsOQq78B_450Meta } from "/var/www/2025-06-20_18_41/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationc0QPe1VcXEjVh9GC_YKBUtF7nQuAKRoUFrZHA1K2vEEMeta } from "/var/www/2025-06-20_18_41/pages/mobile-application.vue?macro=true";
import { default as indexfNK_rJKBAFYOH_450wW2Q6_Q_45AJ5jGatKqK4HpS_husfUMeta } from "/var/www/2025-06-20_18_41/pages/order/create/index.vue?macro=true";
import { default as boateMl7Qmuj6HXlsHNN_cMLS9aiLUr4NsldNOSQq64MymgMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/boat.vue?macro=true";
import { default as sofaD2T_57NwnhylKI3qkq8UvF7zEB_CqYgmaPvG_O1Pmv4Meta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboard0D4DZwv8gOHHFmqTzzMLq6TcC4895bs7byuy5oUZDMUMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesPq_45MuziUDnDv0DS6MkTCOFhR1JV30mJjMzBGrRaZkBAMeta } from "/var/www/2025-06-20_18_41/pages/personal/promocodes.vue?macro=true";
import { default as benchH1bBZmMQkWSCTR3xl3XgVAszToqT2EinRguQaxM18b4Meta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/bench.vue?macro=true";
import { default as booksitKswMaxUH3_45YKL_45owU0LGOSVVBc5NlaiYMRgO555bYMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/books.vue?macro=true";
import { default as cableThdbeehC7u7OpIY72s3oIxPcrXy_haFUy7e4pRDYK1QMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/cable.vue?macro=true";
import { default as chairuL30HmFS_eoda8Yxd77s3rmgios9rhaW810Ga42wEtEMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsB8XhNHrL3m6DlTruczoXNo_45XWoU21jEVZcNyHXqXiSEMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/goods.vue?macro=true";
import { default as index_45QnlUtNMrbKHzImB5l8ukwW8Bd61Pl7jJHL_n3NnOz8Meta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/index.vue?macro=true";
import { default as metal3lkdl9uBB8CsX4uYYElb18GMSGr7Hi_OT1u05TNh3zoMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoywBDzHg4z1EQBE60ANBU9NSjYqbKy5z_45BI9bVnBE7LYMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/piano.vue?macro=true";
import { default as pipes0tDCJoJV3IzqdBrq5zejtFPudMAQ8mG7hKOgwQlCbNIMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsEWKyA83hKWBiLxPupGVL855ngk0GXvk4TAzyeiCFSeoMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxK8EuFoFutYIbr6ifzDPal7P8sTUGS_45wCbYkubGgTiQgMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93INy3y21EhkUXd4xpL4VQOVx0nlQFCBIqBXeEZGkCijYMeta } from "/var/www/2025-06-20_18_41/pages/personal/bonus/[tab].vue?macro=true";
import { default as printVoreAu0vE8j_4ytc7ge9BQjXad2ZAJLduUT9_TyvTDsMeta } from "/var/www/2025-06-20_18_41/pages/personal/order/print.vue?macro=true";
import { default as dishesYRYpecOUplo20neHo9MK7WFsgIMzz6S5YOsx90OiTNYMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/dishes.vue?macro=true";
import { default as engine3tsUy_45XwhN9y46GVvyUW_fP1LalanR8WXzY112uaS8AMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberZ1gaJIjmvY9R3uKdxggBrCJ3buYarmCq6HAPfSJd4RUMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheels0MixQokNtpYrmVci5seY2UfuJn09zHAKJqgJ5rqUoOYMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmJUb1NMT1CVwQLhKWm_9mFP20DVS2A_45C_vLkNBAtFJu0Meta } from "/var/www/2025-06-20_18_41/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingZ2cb03WhMGYGSFedpic_45709TiF5gm8fFdp8LB3CVVSgMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalcCipqsjn0RYpg_3Z8t2L7wZWAJrqjA7ju829VsKJpe8Meta } from "/var/www/2025-06-20_18_41/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93XcvkRd8xwqdg39O6jPjfoPaW10UxvO9TiXxw5kJ5iSMMeta } from "/var/www/2025-06-20_18_41/pages/personal/order/[guid].vue?macro=true";
import { default as create14OIvIJSyERUShdWh6NsA3WiLKOsj8HXOiztXz8uKqYMeta } from "/var/www/2025-06-20_18_41/pages/personal/order/create.vue?macro=true";
import { default as barrels1ogH7f4ktGU5_45sAWEKo66erLWwrnuj6yvH3fAMNMQbIMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesxbjyavJHasBVuFhW4zADTXnltQTO9FMnZgu9dFzcpTkMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragilefy2Rdp95BoZERi8qTUgCceZ4vj3sy2_456Ka4R5xnO9XcMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerJLE9J04BUff0Gub1PqPpo5bcnAUHvAY_458AKgAYHVD64Meta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagegrWT2Zaknmnqa8gSvKzFP5dkvn7Xkp8up2k9ppxmOrgMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45success4Qo5XlVJRcLBD3gHTMsxmPa_45ULpOaLvLWf_45psNx_VwkMeta } from "/var/www/2025-06-20_18_41/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagemm1Es1FpTrQC7H5D1EpzgGHAa86cIbumKeiFImWc74wMeta } from "/var/www/2025-06-20_18_41/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberries74lXuHrxXwwR3Yy_I80UVVl4V_45Bu4CXlMd5vpc6YKowMeta } from "/var/www/2025-06-20_18_41/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93jq8mJK90JkdCYcqguHZVDLFVsv2QglrV_4585NO6_450_1gMeta } from "/var/www/2025-06-20_18_41/pages/order/administer/[guid].vue?macro=true";
import { default as furniturefPQagZOwPYlddhbJ7bz2_uOEHbeaH4v9_453qtlbSzm2kMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversized_lcvy6OdTJMh0s2LajS0Z4mMEDzORdh8n_453UIKmnvJ0Meta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikedw_WafEbc5av_pRu9D_454QFyw4o2Mwimv479lRMf9QWoMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93ap06Eqt0AT83eVtd5eea3GEBv6NtwNJ4N_gwIgE2jscMeta } from "/var/www/2025-06-20_18_41/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93GZKZIornIk_459ovukl3Kd_QJ6g1xpLYLlsequYJaY9OQMeta } from "/var/www/2025-06-20_18_41/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsEAUb_eAt5h27oNFZioPwHyYpEnHDZfm3GXHLea6atpEMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersTcNPqO9_45eDLlekPUBV0s1qk3SFafa8Ou_Y9KWbLPWkwMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoXVh26KdXMh9xfO2wxCxJaLgBKdv8kGnc1N3t9dd1_459kMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileQjGKF4pEeQBs741D624wD8ZkkbAvnfKIGVDTccUc8cEMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexPxzMk6ZkmCQxA71EGO1ed1ajBka0zvinb7ZgXGfjeX8Meta } from "/var/www/2025-06-20_18_41/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketDh24_xQrpBqM0VogHlfNlj0_FZ5K6CU5XlCXhVbQvpEMeta } from "/var/www/2025-06-20_18_41/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesSceQxRPq2djqnP50yYFI0_45CzPb_45K86BDamgEIcPi5yIMeta } from "/var/www/2025-06-20_18_41/pages/personal/orders/templates.vue?macro=true";
import { default as index2CngvyFUYqdcWjeBvBOS2XhHoHCn1YJubtvwYzNhzJYMeta } from "/var/www/2025-06-20_18_41/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorq5pQCJsRc_mbi6VUGhKd48EQ4q0jdWqz3X9kKN88s7kMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93_456I4XOshLKELA8AWugAIQRaLgAc3yBzdIR9dBpUqYC8Meta } from "/var/www/2025-06-20_18_41/pages/personal/contractors/[guid].vue?macro=true";
import { default as index1_45vtQquM9_45UiEkPOqi4ZyS2m3qtaH10TMX9aRb1guIoMeta } from "/var/www/2025-06-20_18_41/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_935Hdk3a6wM3W7VHs2fd_45C0MWUV2qNEUdvtUTCr_45lRDJoMeta } from "/var/www/2025-06-20_18_41/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsHWIOZi3ilDcxy_45t2jsgCaXLRM18MTEWPers5NMe9UFoMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexHtqZGhBbq1r4h9Sz0rt_45OyV7ReDkJQNWU1Y_45baV2MNUMeta } from "/var/www/2025-06-20_18_41/pages/personal/group-printing/index.vue?macro=true";
import { default as indexS_tMU8BG_458vIqELaeW9qZyhlsdoUGd94DzYjeUMWAAcMeta } from "/var/www/2025-06-20_18_41/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45deviceso35YfZUFUcDyj_451lUk81Dhx7awtskvUJraF92GLGTU0Meta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_9379ABoZ3TJzcEdN8_o2C4qR6Zb0QomAd9cJLC0iccxVwMeta } from "/var/www/2025-06-20_18_41/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93YEL52vhbwgd_U_45leZCkJjNRdmzc_45JysI2xa3n6djFKsMeta } from "/var/www/2025-06-20_18_41/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93AgTNQ5VZsn9q56tQdtWaOYl60BCQ_4506PoKQqnXZmPq0Meta } from "/var/www/2025-06-20_18_41/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment6rQmc5HlGOnCc7u9x_kbsjLxeEVrD0z73MKPCEGUyEUMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materials3gf9R6ydqu0xJhVAQOEoDBJCNG1mvPchnY1oUNoXMNkMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instruments1a8SXHLRtjnwRcd3na6JCLK7uN6fJnPe5PGCHCt0BmMMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentMYAZ5QaZFwFeuDgyPZbUKh6SD1JSNwabXYH_452OL5F1sMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportation6WUk4ExK6RFutcX7avyGc5l4Q5snIkRBpKB_45K4qJ_MoMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93ryjWIAJM0GiY1pG6pN1LbhVDjQkdqSjsYEIg3FKl1NgMeta } from "/var/www/2025-06-20_18_41/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationI_Rgq0m0JYCDOisQxJ7YE_45PB75_45TWuNkzampta1LstMMeta } from "/var/www/2025-06-20_18_41/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-06-20_18_41/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-06-20_18_41/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-06-20_18_41/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-06-20_18_41/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-06-20_18_41/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_934Z_45LFUpbPLDSPuWGnAd0eJtuxh9CzgRaVVSjohlNR88Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-06-20_18_41/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-06-20_18_41/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-06-20_18_41/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-06-20_18_41/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursGY7WozxhENOA_45xSRESbIh6DthjyQddUD0ASJ4SgLQkcMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-06-20_18_41/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-06-20_18_41/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-06-20_18_41/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsw2qFJvpMnEq7px1X_yTIC91LBKtjCEm9BRzFEj9w3lUMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-06-20_18_41/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-06-20_18_41/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-06-20_18_41/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-06-20_18_41/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-06-20_18_41/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-06-20_18_41/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-06-20_18_41/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-06-20_18_41/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeUwkHIx_45g20YsvAhTRhhqbGHA0TpwCIrDsbHIhvLcLcsMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93vGcHOrstk1QU_A7FAHSHWzLB5IKj28c1rXfH8nR7iBAMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-06-20_18_41/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-06-20_18_41/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-06-20_18_41/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-06-20_18_41/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-06-20_18_41/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-06-20_18_41/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexG_45eT5wb5JupZCmUWidvHfIGFAswREpvD0GdMQZYBo2YMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-06-20_18_41/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-06-20_18_41/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructor39aMEy8Q00_45dUBGwzWLcPykXd0TEAkcvdWFXG_x88P0Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexGKo_Qf4txA4xrsAlAST45a_K5FI58OWiKiIM_JZbva4Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-06-20_18_41/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-06-20_18_41/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93GMuf3Gb_45aCaTjz1QSQWypX5QmSXSiv7PZrTJ4wuuoG8Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-06-20_18_41/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-06-20_18_41/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-06-20_18_41/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-06-20_18_41/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-06-20_18_41/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-06-20_18_41/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-06-20_18_41/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-06-20_18_41/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-06-20_18_41/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayk0PeYBDJfnF7mDEQ7pujIhv5NLgZmcPKYc_45r_Q_45ILOAMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageVFuoZvwjGMoYtr6yxm0phec4xlL9W2lJWzGUWkATZXIMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-06-20_18_41/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-06-20_18_41/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffszI4VZN_Vc06A4HWvxEwjF_oLR59vcnQjlzBluSaKmeAMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexBCzQL2WUVsxMKSvkQve9rWTVyCBCIiZa33vM3RM5xu4Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-06-20_18_41/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-06-20_18_41/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-06-20_18_41/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-06-20_18_41/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-06-20_18_41/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-06-20_18_41/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importwmfHETvEJNnHnq8NGbr0r8l2gYEs8qzC7wu1S157CMkMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logout9c4uKJ37I9Marz6VlHrU_mLiQ9pQkfCZQkLX8j_45TrdEMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-06-20_18_41/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-06-20_18_41/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024OVEFshMTxdomjfCNLa1J1W6gSDDiX3ydh3AmgvBhW00Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonA0d03QU_4585b0SBUs0fnmZ3o50KEYDJlAOJk3fxsBHcgMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-06-20_18_41/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: account6yJSvX_GkhKTBJjcZbBnWIgElbF3KerZ0osUVIRaeskMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-06-20_18_41/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-06-20_18_41/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-06-20_18_41/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-06-20_18_41/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorPPKlUe11CX9FDlChTfM2bEXPw_45BKWhTHrL3sDGL3aEQMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-06-20_18_41/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-06-20_18_41/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountAhUH_45oN6NCLvUSplTz_45Jvu98HRHuGAO3F2PL3dRqICEMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-06-20_18_41/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917r1HXmRMCOK_8nNtuevBTlADLJojscdpEWVsOQq78B_450Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-06-20_18_41/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexfNK_rJKBAFYOH_450wW2Q6_Q_45AJ5jGatKqK4HpS_husfUMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesPq_45MuziUDnDv0DS6MkTCOFhR1JV30mJjMzBGrRaZkBAMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93INy3y21EhkUXd4xpL4VQOVx0nlQFCBIqBXeEZGkCijYMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printVoreAu0vE8j_4ytc7ge9BQjXad2ZAJLduUT9_TyvTDsMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-06-20_18_41/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93XcvkRd8xwqdg39O6jPjfoPaW10UxvO9TiXxw5kJ5iSMMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create14OIvIJSyERUShdWh6NsA3WiLKOsj8HXOiztXz8uKqYMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-06-20_18_41/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-06-20_18_41/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberries74lXuHrxXwwR3Yy_I80UVVl4V_45Bu4CXlMd5vpc6YKowMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93GZKZIornIk_459ovukl3Kd_QJ6g1xpLYLlsequYJaY9OQMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexPxzMk6ZkmCQxA71EGO1ed1ajBka0zvinb7ZgXGfjeX8Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketDh24_xQrpBqM0VogHlfNlj0_FZ5K6CU5XlCXhVbQvpEMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesSceQxRPq2djqnP50yYFI0_45CzPb_45K86BDamgEIcPi5yIMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: index2CngvyFUYqdcWjeBvBOS2XhHoHCn1YJubtvwYzNhzJYMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93_456I4XOshLKELA8AWugAIQRaLgAc3yBzdIR9dBpUqYC8Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: index1_45vtQquM9_45UiEkPOqi4ZyS2m3qtaH10TMX9aRb1guIoMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_935Hdk3a6wM3W7VHs2fd_45C0MWUV2qNEUdvtUTCr_45lRDJoMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexHtqZGhBbq1r4h9Sz0rt_45OyV7ReDkJQNWU1Y_45baV2MNUMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexS_tMU8BG_458vIqELaeW9qZyhlsdoUGd94DzYjeUMWAAcMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_9379ABoZ3TJzcEdN8_o2C4qR6Zb0QomAd9cJLC0iccxVwMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93YEL52vhbwgd_U_45leZCkJjNRdmzc_45JysI2xa3n6djFKsMeta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93AgTNQ5VZsn9q56tQdtWaOYl60BCQ_4506PoKQqnXZmPq0Meta || {},
    component: () => import("/var/www/2025-06-20_18_41/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-06-20_18_41/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-06-20_18_41/pages/shippingtypes/personalitemstransportation.vue")
  }
]